import React, { ReactNode } from 'react';
import { Button } from 'reactstrap';
import Sensor from 'modules/Sensor/model/Sensor';
import BaseModal from 'modules/Layout/component/Modal';
import InformationList, {
  InformationField
} from 'modules/Layout/component/InformationList';
import Loader from 'modules/Layout/component/Loader';
import { Message } from 'modules/Shared/type';
import Alert from 'modules/Layout/component/Alert';

export interface Props {
  onSubmit: (sensor: Sensor) => void;
  fetching: boolean;
  errorMessage?: Message | null;
}

export interface State {
  isOpen: boolean;
  sensor?: Sensor;
}

class SensorDeleteModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
      sensor: null
    };

    this.openModal = this.openModal.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  openModal(sensor: Sensor): void {
    const state: State = {
      isOpen: true,
      sensor
    };

    this.setState(state);
  }

  toggle(): void {
    this.setState({
      isOpen: false
    });
  }

  renderTitle = (): React.ReactNode => {
    const { sensor } = this.state;

    if (sensor) {
      return `Delete sensor ${sensor.mac_address} for user ${sensor.user_id}`;
    }

    return null;
  };

  renderBody(): React.ReactNode {
    const { fetching, errorMessage } = this.props;
    const { sensor } = this.state;

    if (sensor) {
      const fields: InformationField[] = [
        {
          label: 'Mac Address',
          value: sensor.mac_address
        },
        {
          label: 'Nickname',
          value: sensor.nickname
        },
        {
          label: 'User Id',
          value: sensor.user_id
        },
        {
          label: 'User Email',
          value: sensor.email
        }
      ];

      return (
        <>
          {errorMessage && <Alert message={errorMessage} />}
          {fetching && <Loader />}
          <InformationList fields={fields} />
        </>
      );
    }

    return null;
  }

  renderFooter(): React.ReactNode {
    const { onSubmit } = this.props;
    const { sensor } = this.state;

    return (
      <div className="d-flex justify-content-between w-100">
        <Button color="secondary" onClick={this.toggle}>
          Cancel
        </Button>
        <Button color="danger" onClick={() => onSubmit(sensor)}>
          Delete
        </Button>
      </div>
    );
  }

  render(): ReactNode {
    const { isOpen } = this.state;

    return (
      <BaseModal
        isOpen={isOpen}
        title={this.renderTitle()}
        body={this.renderBody()}
        footer={this.renderFooter()}
        toggle={this.toggle}
      />
    );
  }
}

export default SensorDeleteModal;
